<template>
    <span />
</template>

<script>
    export default {
        name: "VueSpeak",
        props:{
            message:{
                type:String,
                default:''
            },
            voiceName:{
                type:String,
                default:"Zira"
            }
        },
        watch: {
            message: function () {//newQuestion, oldQuestion
                this.getSpeak();
            }
        },
        created: function () {
            console.log("Loaded speak module");
            // eslint-disable-next-line no-undef
            // this.debouncedSpeek = _.debounce(this.getSpeak, 1000);
            this.synth = window.speechSynthesis;
            this.voice = this.synth.getVoices().find((voice)=>{
                return voice.name.includes(this.voiceName);
            });
        },
        methods: {
            getSpeak: function () {
                // if(this.message.length > 0){
                    // eslint-disable-next-line no-undef
                    let utterThis = new SpeechSynthesisUtterance(this.message);
                    if(this.voice) utterThis.voice = this.voice;
                    this.synth.speak(utterThis);
                // }
            }
        }
    }
</script>

<style scoped>

</style>